module.exports = __webpack_public_path__ + "img/empty.d9d1e756.png";